
$.formUtils.addValidator({
	name : 'unique',
	validatorFunction : function(value, $el, config, language, $form) {
		var actualValue = $el.val(); // needed because validator framework trims the 'value': 'COLORE ' becomes 'COLORE'
		if(actualValue != undefined && actualValue != '') {
			var data = $form.data('inputData');
			var field = $el.data('validation-unique-field');
			var entity = $el.data('validation-unique-entity');
			var idField = $el.data('validation-unique-id-field');
			var id = (data && data[idField] !== undefined) ? data[idField] : '';

			var input = {
				value: actualValue,
				property: field,
				entity: entity,
				id: id
			};
			return dashboardInstance.invokeProvider('com.hrd.struts.validator.CommonValidatorJsonProvider', 'validateUnique', input).then(r => r.isValid);
		} else {
			return true;
		}
	},
	errorMessage : 'This field must be unique',
	errorMessageKey: 'notUnique'
});
